// 课程详情页
export function goCourse({ dispatch }, params) {
  // console.log(params)
  dispatch('goPush', {
    name: 'courseInfo', // 路由名
    params: params
  })
}

// 老师主页
export function goTeacher({ dispatch }, params) {
  //   console.log(params)
  dispatch('goPush', {
    name: 'teacherInfo', // 路由名
    params: params
  })
}
